/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link as LinkDom } from 'react-router-dom';
import Icon, { IconType, IconSize } from '../icon/icon';

export const LinkTheme = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  INFO: 'info',
  LIGH: 'ligh',
  DARK: 'dark',
  '': '',
};

export const LinkSize = {
  BLOCK: 'block',
  LARGE: 'lg',
  SMALL: 'sm',
  '': '',
};

/**
 * Basic link component, it’s designed to edit the href attribute
 */
const Link = (props) => {
  const {
    id, theme, size, children, className, icon, iconColor, iconSize, disabled, to,
  } = props;
  const classProps = classNames(
    'btn',
    `btn-${theme}`,
    `btn-${size}`,
    className,
  );
  return (
    <LinkDom
      id={id}
      disabled={disabled}
      className={theme !== '' ? classProps : ''}
      to={to}
    >
      { icon !== ''
         && (
         <Icon
           icon={icon}
           size={iconSize}
           color={iconColor}
         />
         )}
      {children}
    </LinkDom>
  );
};

Link.propTypes = {
  id: PropTypes.string,
  /**
   * Link background color
   */
  theme: PropTypes.oneOf(Object.values(LinkTheme)),
  /**
   * Link general size
   */
  size: PropTypes.oneOf(Object.values(LinkSize)),
  /**
   * Content to put inside the link component
   */
  children: PropTypes.node,
  /**
   * CSS classes to customize link
   */
  className: PropTypes.string,
  /**
   * To select a icon inside the link
   */
  icon: PropTypes.oneOf(Object.values(IconType)),
  /**
   * Icon color inside the link
   */
  iconColor: PropTypes.string,
  /**
   * Icon size inside the link
   */
  iconSize: PropTypes.oneOf(Object.values(IconSize)),
  /**
   * To disable the link functionality
   */
  disabled: PropTypes.bool,
  /**
   * Link reference
   */
  to: PropTypes.string.isRequired,
};

Link.defaultProps = {
  id: '',
  theme: '',
  size: LinkSize.SMALL,
  children: null,
  className: '',
  icon: '',
  iconColor: '',
  iconSize: IconSize.SMALL,
  disabled: false,
};

export default Link;
